import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Custombutton from "../../../utils/Custombutton";

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const { firstName, lastName, email, phone } = formData;
    if (!firstName.trim() || !lastName.trim() || !email.trim() || !phone.trim()) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "First Name, Last Name, Email, and Phone are required.",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    try {
      const response = await axios.post(
        "http://localhost:4000/api/save-contactus-data",
        formData
      );
      setLoading(false);

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your message has been sent successfully!",
        });
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          message: "",
        });
      }
    } catch (err) {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "There was an error sending your message. Please try again.",
      });
    }
  };

  return (
    <div id="contact">
      <div className="hero partner contact">
        <div className="night">{/* <ShimmeringParticles /> */}</div>
        <div className="px-0 py-3 px-xxl-4 py-xxl-4">
          <div className="container">
            <div
              className="news"
              style={{ background: "none", margin: "0px !important" }}
            >
              <h4>LET's</h4>
              <h1>
                <div
                  className="position-relative partner-heading"
                  style={{
                    display: "flex",
                    alignItems: "end",
                  }}
                >
                  <h1>Talk</h1>
                  <h6 className="ms-3 w-100">Fill the form</h6>
                </div>
              </h1>
              <div className="contact-form">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-6 mb-4">
                      <input
                        type="text"
                        placeholder="First Name"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg-6 mb-4">
                      <input
                        type="text"
                        placeholder="Last Name"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg-6 mb-4">
                      <input
                        type="email"
                        placeholder="Email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg-6 mb-4">
                      <input
                        type="tel"
                        placeholder="Phone Number"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-xl-12 mb-4">
                      <textarea
                        placeholder="Message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="text-end d-flex align-items-center justify-content-end">
                      <Custombutton
                        label={loading ? "Sending..." : "Send"}
                        className={"btn-bg rounded-3 p-4 px-5"}
                        disabled={loading}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
